import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/Index";
import "../types/tawk";

const ALLOWED_HOSTNAMES = [
  "www.staging.muzukuru.com",
  "www.mms.muzukuru.com",
  "staging.muzukuru.com",
  "mms.muzukuru.com",
];
const TAWK_SRC = "https://embed.tawk.to/6a3e952fc42fa81d53df93eb/default";
const TAWK_SCRIPT_ID = "tawk-to-script";

const TawkChat = () => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    window.Tawk_API?.setAttributes?.(
      {
        source: "mms-internal",
        page: location.pathname,
        pageUrl: window.location.href,
        "First Name": user?.first_name ?? "",
        "Last Name": user?.last_name ?? "",
        "User ID": user?.id?.toString() ?? "",
        role: user?.group_names?.join(", ") ?? "",
        username: user?.username ?? "",
      },
      (error: unknown) => {
        if (error) console.warn("TawkChat: setAttributes failed", error);
      },
    );
  }, [location.pathname, user]);

  useEffect(() => {
    if (!ALLOWED_HOSTNAMES.includes(window.location.hostname)) return;
    if (document.getElementById(TAWK_SCRIPT_ID)) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    s1.id = TAWK_SCRIPT_ID;
    s1.async = true;
    s1.src = TAWK_SRC;
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    s1.onerror = () => console.error("TawkChat: failed to load script");

    const s0 = document.getElementsByTagName("script")[0];
    s0.parentNode?.insertBefore(s1, s0);

    return () => {
      document.getElementById(TAWK_SCRIPT_ID)?.remove();
      window.Tawk_API?.hideWidget?.();
      delete window.Tawk_API;
      delete window.Tawk_LoadStart;
    };
  }, []);

  return null;
};

export default TawkChat;
